import { useMutation } from "@tanstack/react-query";
import { SettingsService } from "../../services/settings.service";
import { ISettings } from "../../models/Settings";
import { IMaintenanceSettings } from "../../models/MaintenanceSettings";

export const useSettingsMutations = () => {
  const { mutate: editSettings } = useMutation<any, Error, Omit<ISettings, "id">>({
    mutationFn: async (model: Omit<ISettings, "id">) => SettingsService.updateSettings(model),
  });

  const { mutate: editMaintenanceSettings } = useMutation<
    any,
    Error,
    Omit<IMaintenanceSettings, "id">
  >({
    mutationFn: async (model: Omit<IMaintenanceSettings, "id">) =>
      SettingsService.updateMaintenanceSettings(model),
  });

  return {
    editSettings,
    editMaintenanceSettings,
  };
};
